import { createAsyncThunk } from "@reduxjs/toolkit";
// Import Axios Admin API (this is where the baseURL is and shared reuqest params are set)
import api from "../../utils/api";
import { setAlert } from "../alerts/actions";



export const get = createAsyncThunk("smtp/get", async (id, { dispatch }) => {
    try {
        const res = await api.get(`/admin/smtp`);
        return res.data;
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});

export const edit = createAsyncThunk("smtp/edit", async ({ data, navigate }, { dispatch }) => {
    try {
        await api.put(`/admin/smtp`, data);
        dispatch(setAlert({ message: 'SMTP settings updated successfully', alertType: 'success' }))
        navigate(`/cms/smtp`);
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});
